export const apiRoutes = {
  routeLogin: 'auth/auth/login',
  routeLogout: 'login/logout/',
  routeRefresh: 'auth/auth/refresh/',
};
